import React from 'react';

import { DateFormat, formatDate } from '@lyearn/core/utils/date/formatDate';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

import { FrequencyComponentProps } from '../../../types';

const DateInputMemo = React.memo<FrequencyComponentProps>(
  ({ className, value, disabled, size }) => {
    const startDate = value.startDate || new Date().toString();
    return (
      <Box className={className ?? 'w-1/2'}>
        <Box
          className={cn(
            'flex w-full flex-row items-center rounded-8 border border-solid border-field bg-bg-secondary px-16 py-8',
            size === 'medium' ? 'h-40' : 'h-48',
          )}>
          <Typography
            color={disabled ? 'text-text-secondary' : 'text-text-primary'}
            numberOfLines={1}
            variant={size === 'medium' ? 'body-short-02' : 'body-short-01'}>
            {formatDate(startDate, DateFormat.Date)}
          </Typography>
        </Box>
      </Box>
    );
  },
);

export default DateInputMemo;
